(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("livecodes"));
	else if(typeof define === 'function' && define.amd)
		define(["livecodes"], factory);
	else if(typeof exports === 'object')
		exports["platon-code-editor-vue2"] = factory(require("livecodes"));
	else
		root["platon-code-editor-vue2"] = factory(root["livecodes"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__4756__) {
return 